import { graphqlClient } from 'spw-api/utils';
import { gql } from '@apollo/client';
import { IMinimalSpace, ISpace } from 'spw-redux/modules/floorplan/types';
import { removeTypeNameFromObject } from 'spw-shared/utils';
import { omit } from 'ramda';
import { SPACE_FIELDS } from 'spw-api/esa_fragments';

export const createSpace = (space: ISpace | IMinimalSpace) => {
  return graphqlClient.mutate<{ newSpace: ISpace }>({
    fetchPolicy: 'no-cache',
    mutation: gql`
      ${SPACE_FIELDS}
      mutation CreateSpace($space: CreateSpaceArgs!) {
        newSpace: createSpace(space: $space) {
          ...SpaceFields
        }
      }
    `,
    variables: {
      space: {
        ...space,
        roomName: space.roomName || '',
        roomNumber: space.roomNumber || '',
        seatCount: space.seatCount || 0,
        floorplanPoint: removeTypeNameFromObject(space.floorplanPoint),
        usf: space.usf || 0,
      },
    },
  });
};

export const getFloorSpacesApi = (floorId: number) =>
  graphqlClient.query<{ floorSpaces: ISpace[] }>({
    fetchPolicy: 'no-cache',
    query: gql`
      ${SPACE_FIELDS}
      query GetFloorSpaces {
          floorSpaces(id: ${floorId}) {
              ...SpaceFields
          }
      }`,
  });

export const updateSpace = (space: ISpace, shouldUpdateUsf = false) =>
  graphqlClient.mutate<{ updatedSpace: ISpace }>({
    mutation: gql`
      ${SPACE_FIELDS}
      mutation UpdateSpace($id: ID!, $space: UpdateSpaceArgs!) {
        updatedSpace: updateSpace(id: $id, space: $space) {
          ...SpaceFields
        }
      }
    `,
    variables: {
      id: space.id,
      space: omit(['id'], {
        ...space,
        usf: shouldUpdateUsf ? space.usf : undefined,
      }),
    },
  });

export const updatePosition = (
  id: number,
  previousSpaceId?: number,
  nextSpaceId?: number
) =>
  graphqlClient.mutate<{ updatedSpace: { id: number; rank: string } }>({
    mutation: gql`
      mutation updateSpacePosition(
        $id: ID!
        $previousSpaceId: ID
        $nextSpaceId: ID
      ) {
        updatedSpace: updateSpacePosition(
          id: $id
          previousSpaceId: $previousSpaceId
          nextSpaceId: $nextSpaceId
        ) {
          id
          rank
        }
      }
    `,
    variables: {
      id,
      previousSpaceId,
      nextSpaceId,
    },
  });
